// extracted by mini-css-extract-plugin
export default {"Skill":"SkillTemp_Skill__f4a8g","SkillIcon":"SkillTemp_SkillIcon__8Nh+m","SkillName":"SkillTemp_SkillName__SJTfb"};